import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ProductPage from "./pages/ProductPage";
import MethodologiePage from "./pages/MethodologiePage";
import SecuritePage from "./pages/SecuritePage";
import PourquoiCayusPage from "./pages/PourquoiCayusPage";
import PilotPage from "./pages/PilotPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import ContactPage from "./pages/ContactPage";
import BlogListPage from "./pages/BlogListPage";
import BlogPostPage from "./pages/BlogPostPage";
import LeadsPage from "./pages/LeadsPage";
import ProgrammePilotePage from "./pages/ProgrammePilotePage";
import DiagnosticPage from "./pages/DiagnosticPage";
import BlogAdminPage from "./pages/BlogAdminPage";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/pilot" element={<PilotPage />} />
            <Route path="/produit/managers" element={<ProductPage slug="managers" />} />
            <Route path="/produit/senior-managers" element={<ProductPage slug="senior-managers" />} />
            <Route path="/produit/rh" element={<ProductPage slug="rh" />} />
            <Route path="/produit/comite-executif" element={<ProductPage slug="comite-executif" />} />
            <Route path="/methodologie" element={<MethodologiePage />} />
            <Route path="/securite" element={<SecuritePage />} />
            <Route path="/pourquoi-cayus" element={<PourquoiCayusPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/blog-admin" element={<BlogAdminPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/programme-pilote" element={<ProgrammePilotePage />} />
            <Route path="/diagnostic" element={<DiagnosticPage />} />
            <Route path="/leadership-gap" element={<Navigate to="/blog/leadership-des-milliards-investis-mais-un-impact-toujours-introuvable" replace />} />
            <Route path="/fr/accueil" element={<Navigate to="/" replace />} />
            <Route path="/fr/accueil/" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
